// extracted by mini-css-extract-plugin
export default {"stores":"StoreList_stores__xmcXw"};